import { useState, useEffect, useRef } from 'react';
import Layout from '../components/Layout';
import { ticketsApi, actualizarTicketApi, usuariosApi, listarArchivosTicketApi, subirArchivoTicketApi, eliminarArchivoApi, urlArchivo, descargarPDFApi } from '../api';

export default function Tickets() {
  const [tickets, setTickets] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [filtros, setFiltros] = useState({ estado: 'abierto', asignado_a: '', prioridad: '' });
  const [ticketSeleccionado, setTicketSeleccionado] = useState(null);
  const [cargando, setCargando] = useState(true);

  const cargar = async () => {
    setCargando(true);
    try {
      const params = {};
      if (filtros.estado)     params.estado     = filtros.estado;
      if (filtros.asignado_a) params.asignado_a = filtros.asignado_a;
      if (filtros.prioridad)  params.prioridad  = filtros.prioridad;
      const res = await ticketsApi(params);
      setTickets(res.data);
    } catch(err) { console.error(err); }
        finally { setCargando(false); }
  };

  useEffect(() => {
    cargar();
    usuariosApi().then(r => setUsuarios(r.data.filter(u => u.activo))).catch(console.error);
  }, [filtros]);

  const actualizar = async (id, data, setGuardando) => {
    try {
      if (setGuardando) setGuardando(true);
      await actualizarTicketApi(id, data);
      cargar();
      setTicketSeleccionado(null);
    } catch(err) {
      alert('Error al actualizar');
    } finally {
      if (setGuardando) setGuardando(false);
    }
  };

  return (
    <Layout titulo="Tickets">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', flexWrap: 'wrap', gap: 8 }}>
        <p style={{ fontSize: 20, fontWeight: 600, color: '#fff' }}>Tickets</p>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <select style={{ width: 'auto', padding: '7px 10px', background: '#1a1a1a', border: '1px solid #2a2a2a', color: '#fff', borderRadius: 8, outline: 'none' }} value={filtros.estado} onChange={e => setFiltros({ ...filtros, estado: e.target.value })}>
            <option value="">Todos los estados</option>
            <option value="abierto">Abierto</option>
            <option value="en_proceso">En proceso</option>
            <option value="cerrado">Cerrado</option>
          </select>
          <select style={{ width: 'auto', padding: '7px 10px', background: '#1a1a1a', border: '1px solid #2a2a2a', color: '#fff', borderRadius: 8, outline: 'none' }} value={filtros.prioridad} onChange={e => setFiltros({ ...filtros, prioridad: e.target.value })}>
            <option value="">Todas las prioridades</option>
            <option value="alta">Alta</option>
            <option value="normal">Normal</option>
            <option value="baja">Baja</option>
          </select>
          <select style={{ width: 'auto', padding: '7px 10px', background: '#1a1a1a', border: '1px solid #2a2a2a', color: '#fff', borderRadius: 8, outline: 'none' }} value={filtros.asignado_a} onChange={e => setFiltros({ ...filtros, asignado_a: e.target.value })}>
            <option value="">Todos los tecnicos</option>
            {usuarios.map(u => <option key={u.id} value={u.id}>{u.nombre} {u.apellido}</option>)}
          </select>
        </div>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {cargando ? (
          <p style={{ padding: '2rem', textAlign: 'center', color: '#555' }}>Cargando...</p>
        ) : tickets.length === 0 ? (
          <p style={{ padding: '2rem', textAlign: 'center', color: '#555' }}>No hay tickets con esos filtros</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>#</th><th>Fecha</th><th>Institucion</th><th>Sistema</th>
                <th>Asunto</th><th>Prioridad</th><th>Estado</th><th>Asignado a</th><th></th>
              </tr>
            </thead>
            <tbody>
              {tickets.map(t => (
                <tr key={t.id} className={t.prioridad === 'alta' ? 'high' : ''}>
                  <td style={{ color: '#aaa', fontSize: 12 }}>{t.numero}</td>
                  <td style={{ color: '#aaa', fontSize: 11 }}>{new Date(t.created_at).toLocaleDateString('es-AR')}</td>
                  <td>{t.cliente_nombre_db || t.cliente_nombre_libre || '—'}</td>
                  <td>
                    <span style={{ fontSize: 11, background: '#1a1a1a', padding: '2px 7px', borderRadius: 999, color: '#aaa' }}>
                      {t.sistema === 'vuepacs_carestream' ? 'VUEPACS CS' : t.sistema === 'vuepacs_philips' ? 'VUEPACS Ph' : t.sistema || '—'}
                    </span>
                  </td>
                  <td>{t.asunto}</td>
                  <td><span className={`badge badge-${t.prioridad}`}>{t.prioridad}</span></td>
                  <td><span className={`badge badge-${t.estado}`}>{t.estado.replace('_', ' ')}</span></td>
                  <td style={{ fontSize: 12 }}>
                    {t.tecnico_nombre ? `${t.tecnico_nombre} ${t.tecnico_apellido[0]}.` : <span style={{ color: '#444' }}>Sin asignar</span>}
                  </td>
                  <td>
                    <button style={{ fontSize: 12, padding: '4px 10px', background: 'transparent', border: '1px solid #2a2a2a', color: '#aaa', borderRadius: 7, cursor: 'pointer' }} onClick={() => setTicketSeleccionado(t)}>
                      Gestionar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {ticketSeleccionado && (
        <ModalTicket
          ticket={ticketSeleccionado}
          usuarios={usuarios}
          onClose={() => setTicketSeleccionado(null)}
          onGuardar={(data, setGuardando) => actualizar(ticketSeleccionado.id, data, setGuardando)}
        />
      )}
    </Layout>
  );
}

function ModalTicket({ ticket, usuarios, onClose, onGuardar }) {
  const [form, setForm] = useState({
    estado: ticket.estado,
    asignado_a: ticket.asignado_a || '',
    prioridad: ticket.prioridad,
    notas_internas: ticket.notas_internas || '',
    solucion: ticket.solucion || ''
  });
  const [archivos, setArchivos] = useState([]);
  const [subiendo, setSubiendo] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [generandoPDF, setGenerandoPDF] = useState(false);
  const [tab, setTab] = useState('gestion');
  const fileRef = useRef(null);

  useEffect(() => {
    listarArchivosTicketApi(ticket.id).then(r => setArchivos(r.data)).catch(console.error);
  }, [ticket.id]);

  const subirArchivo = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setSubiendo(true);
    try {
      const fd = new FormData();
      files.forEach(file => fd.append('archivo', file));
      await subirArchivoTicketApi(ticket.id, fd);
      const r = await listarArchivosTicketApi(ticket.id);
      setArchivos(r.data);
    } catch(err) { alert('Error al subir archivos'); }
    finally { setSubiendo(false); }
  };

  const eliminar = async (filename) => {
    if (!window.confirm('Eliminar este archivo?')) return;
    try {
      await eliminarArchivoApi(filename);
      setArchivos(archivos.filter(a => a.nombre_archivo !== filename));
    } catch(err) { alert('Error al eliminar'); }
  };

  const descargarPDF = async () => {
    setGenerandoPDF(true);
    try {
      const res = await descargarPDFApi(ticket.id);
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = `ticket-${ticket.numero}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch(err) { alert('Error al generar PDF'); }
    finally { setGenerandoPDF(false); }
  };

  const esImagen = (tipo) => tipo?.startsWith('image/');

  const tabStyle = (activo) => ({
    padding: '8px 16px', fontSize: 13, fontWeight: activo ? 600 : 400,
    color: activo ? '#1a6fbb' : '#888', background: 'none', border: 'none',
    borderBottom: activo ? '2px solid #1a6fbb' : '2px solid transparent', cursor: 'pointer'
  });

  const Spinner = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round">
      <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83">
        <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite"/>
      </path>
    </svg>
  );

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '1rem' }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: '1.75rem', width: '100%', maxWidth: 580, maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <div>
            <p style={{ fontWeight: 700, fontSize: 15, color: '#111' }}>{ticket.numero} — {ticket.asunto}</p>
            <p style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{ticket.contacto_nombre} · {ticket.contacto_email}</p>
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <button onClick={descargarPDF} disabled={generandoPDF} style={{ fontSize: 12, padding: '6px 12px', background: '#f5f5f5', border: '1px solid #ddd', borderRadius: 7, cursor: 'pointer', color: '#555', display: 'flex', alignItems: 'center', gap: 6 }}>
              {generandoPDF ? 'Generando...' : '📄 PDF'}
            </button>
            <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#aaa' }}>✕</button>
          </div>
        </div>

        <div style={{ display: 'flex', borderBottom: '1px solid #eee', marginBottom: '1.25rem' }}>
          <button style={tabStyle(tab === 'gestion')}  onClick={() => setTab('gestion')}>Gestion</button>
          <button style={tabStyle(tab === 'adjuntos')} onClick={() => setTab('adjuntos')}>
            Adjuntos {archivos.length > 0 && <span style={{ background: '#1a6fbb', color: '#fff', fontSize: 10, padding: '1px 6px', borderRadius: 999, marginLeft: 4 }}>{archivos.length}</span>}
          </button>
        </div>

        {tab === 'gestion' && (
          <>
            <div style={{ background: '#f9f9f9', borderRadius: 8, padding: '12px', marginBottom: '1.25rem', fontSize: 13, color: '#444', lineHeight: 1.6 }}>
              {ticket.descripcion}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#333', marginBottom: 5 }}>Estado</label>
                <select value={form.estado} onChange={e => setForm({ ...form, estado: e.target.value })} style={{ width: '100%', padding: '9px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, background: '#f5f5f5', color: '#111', outline: 'none' }}>
                  <option value="abierto">Abierto</option>
                  <option value="en_proceso">En proceso</option>
                  <option value="cerrado">Cerrado</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#333', marginBottom: 5 }}>Prioridad</label>
                <select value={form.prioridad} onChange={e => setForm({ ...form, prioridad: e.target.value })} style={{ width: '100%', padding: '9px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, background: '#f5f5f5', color: '#111', outline: 'none' }}>
                  <option value="alta">Alta</option>
                  <option value="normal">Normal</option>
                  <option value="baja">Baja</option>
                </select>
              </div>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#333', marginBottom: 5 }}>Asignar a</label>
              <select value={form.asignado_a} onChange={e => setForm({ ...form, asignado_a: e.target.value })} style={{ width: '100%', padding: '9px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, background: '#f5f5f5', color: '#111', outline: 'none' }}>
                <option value="">Sin asignar</option>
                {usuarios.map(u => <option key={u.id} value={u.id}>{u.nombre} {u.apellido}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#333', marginBottom: 5 }}>Notas internas</label>
              <textarea rows={2} placeholder="Notas visibles solo para el equipo..." value={form.notas_internas} onChange={e => setForm({ ...form, notas_internas: e.target.value })} style={{ width: '100%', padding: '9px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, background: '#f5f5f5', color: '#111', outline: 'none' }}/>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: form.estado === 'cerrado' ? '#1a6fbb' : '#333', marginBottom: 5 }}>
                Solucion aplicada {form.estado === 'cerrado' && <span style={{ color: '#e24b4a' }}>*</span>}
              </label>
              <textarea rows={4} placeholder="Describe la solucion aplicada al problema..." value={form.solucion} onChange={e => setForm({ ...form, solucion: e.target.value })}
                style={{ width: '100%', padding: '9px 12px', border: `1px solid ${form.estado === 'cerrado' ? '#1a6fbb' : '#ddd'}`, borderRadius: 8, fontSize: 14, background: form.estado === 'cerrado' ? '#f0f7ff' : '#f5f5f5', color: '#111', outline: 'none' }}/>
              {form.estado === 'cerrado' && !form.solucion && (
                <p style={{ fontSize: 11, color: '#e24b4a', marginTop: 4 }}>La solucion es requerida para cerrar el ticket.</p>
              )}
              {form.estado === 'cerrado' && form.solucion && (
                <p style={{ fontSize: 11, color: '#16a34a', marginTop: 4 }}>Se generara un PDF y se enviara al cliente al guardar.</p>
              )}
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={onClose} disabled={guardando} style={{ padding: '9px 20px', background: 'transparent', color: '#333', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, cursor: 'pointer' }}>Cancelar</button>
              <button
                disabled={guardando}
                onClick={() => {
                  if (form.estado === 'cerrado' && !form.solucion) {
                    alert('Debes completar la solucion para cerrar el ticket');
                    return;
                  }
                  onGuardar(form, setGuardando);
                }}
                style={{ padding: '9px 20px', background: guardando ? '#0c447c' : '#1a6fbb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: guardando ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
              >
                {guardando ? (
                  <><Spinner/>{form.estado === 'cerrado' ? 'Generando PDF...' : 'Guardando...'}</>
                ) : (
                  form.estado === 'cerrado' ? 'Cerrar y enviar PDF' : 'Guardar cambios'
                )}
              </button>
            </div>
          </>
        )}

        {tab === 'adjuntos' && (
          <>
            <div onClick={() => fileRef.current?.click()}
              style={{ border: '1.5px dashed #ddd', borderRadius: 10, padding: '20px', textAlign: 'center', cursor: 'pointer', marginBottom: 16, background: '#fafafa' }}
              onMouseEnter={e => e.currentTarget.style.borderColor = '#1a6fbb'}
              onMouseLeave={e => e.currentTarget.style.borderColor = '#ddd'}>
              <div style={{ fontSize: 24, marginBottom: 6 }}>📎</div>
              <p style={{ fontSize: 13, color: '#888' }}>{subiendo ? 'Subiendo...' : 'Hace clic para adjuntar archivos'}</p>
              <p style={{ fontSize: 11, color: '#bbb', marginTop: 4 }}>JPG, PNG, PDF, DOC, XLS — max. 10MB</p>
            </div>
            <input ref={fileRef} type="file" style={{ display: 'none' }} onChange={subirArchivo} accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.doc,.docx,.xls,.xlsx,.txt" multiple/>

            {archivos.length === 0 ? (
              <p style={{ textAlign: 'center', color: '#bbb', fontSize: 13, padding: '1rem 0' }}>No hay archivos adjuntos</p>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {archivos.map(a => (
                  <div key={a.id} style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#f9f9f9', borderRadius: 8, padding: '10px 12px', border: '1px solid #eee' }}>
                    <span style={{ fontSize: 20 }}>{esImagen(a.tipo_archivo) ? '🖼' : a.tipo_archivo?.includes('pdf') ? '📄' : '📎'}</span>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 13, color: '#111', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.nombre_original}</div>
                      <div style={{ fontSize: 11, color: '#aaa' }}>{(a.tamanio / 1024).toFixed(1)} KB · {a.subido_por_nombre || 'Sistema'} · {new Date(a.created_at).toLocaleDateString('es-AR')}</div>
                    </div>
                    <a href={urlArchivo(a.nombre_archivo)} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#1a6fbb', textDecoration: 'none', padding: '4px 8px', border: '1px solid #1a6fbb', borderRadius: 6 }}>Ver</a>
                    <button onClick={() => eliminar(a.nombre_archivo)} style={{ fontSize: 12, color: '#e24b4a', background: 'none', border: '1px solid #e24b4a', borderRadius: 6, padding: '4px 8px', cursor: 'pointer' }}>✕</button>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}